import about from '@/services/api/about';
import account from '@/services/api/account';
import browse from '@/services/api/browse';
import chart from '@/services/api/chart';
import insight from '@/services/api/insight';
import market from '@/services/api/market';
import profile from '@/services/api/profile';
import support from '@/services/api/support';
import trade from '@/services/api/trade';
import wallet from '@/services/api/wallet';
import dashboard from '@/services/api/dashboard';
import leaderboards from '@/services/api/leaderboards';
import map from '@/services/api/map';

export default {
  about,
  account,
  browse,
  chart,
  insight,
  market,
  profile,
  support,
  trade,
  wallet,
  dashboard,
  leaderboards,
  map,
};



// WEBPACK FOOTER //
// ./src/services/api.js